import { nextTick as r } from "vue";
import { b as s, u as n } from "./fileManager-BNE_Afa-.js";
import l from "./ImageSkeleton.ce.js";
import { _ as d } from "./Button.ce.vue_vue_type_script_setup_true_lang-3QjuPmOY.js";
import u from "./SvgIcon.ce.js";
import m from "dexie";
import c from "./AudioPlayback.ce.js";
import { F as t } from "./index-Ct-O5af5.js";
import { t as p } from "./tooltip-YeSRTnG0.js";
import { D as h } from "./luxon-BFLqgYPH.js";
const o = new m("CommentFile");
o.version(1).stores({
  files: "++id, files "
  // primary key "id" (for the runtime!)
});
const f = {
  [t.pending]: "Stop the upload",
  [t.uploading]: "Stop the uploading",
  [t.uploadSucceed]: "Upload has been succeeded",
  [t.uploadFailed]: "Upload failed",
  [t.loading]: "Delete the file",
  [t.loadSucceed]: "Delete the file",
  [t.loadFailed]: "Delete the file",
  [t.default]: "Delete the file"
}, y = {
  [t.pending]: "Xmark",
  [t.uploading]: "Xmark",
  [t.uploadSucceed]: "Check",
  [t.uploadFailed]: "Xmark",
  [t.loading]: "TrashCan",
  [t.loadSucceed]: "TrashCan",
  [t.loadFailed]: "TrashCan",
  [t.default]: "TrashCan"
}, g = 3, v = {
  name: "CommentUploadFile",
  components: {
    ImageSkeletonCe: l,
    ArboButton: d,
    SvgRenderCe: u,
    AudioPlaybackCe: c
  },
  directives: {
    arboTooltip: p
  },
  props: {
    fileid: { type: String, required: !0 },
    path: { type: String, default: "" },
    mimetype: { type: String, default: "application/octet-stream" },
    name: { type: String, default: "Untitled" },
    thumbnail: { type: String, default: "" }
  },
  data() {
    return {
      fileStorage: n(),
      resourceURL: "",
      thumbnailUrl: this.thumbnail || "",
      renderKey: 0,
      bc: null,
      FileStatus: t,
      retryCount: 0
    };
  },
  computed: {
    uploadStatus() {
      return this.fileStorage?.uploadingStatus?.value?.[this.fileid] || t.loading;
    },
    displayType() {
      return s(this.mimetype);
    },
    iconName() {
      return y[this.uploadStatus];
    },
    fileUploadTooltip() {
      return f[this.uploadStatus];
    }
  },
  mounted() {
    try {
      const e = document.querySelector("main")?.getAttribute("id") || "default";
      this.bc = new BroadcastChannel(`file-upload-channel-${e}`), this.loadResourceLink();
    } catch (e) {
      console.error("[CommentUploadFile] BroadcastChannel error", e);
    }
  },
  beforeUnmount() {
    this.bc?.close();
  },
  methods: {
    updateStatus(e) {
      const a = this.fileStorage?.uploadingStatus?.value;
      a && typeof a == "object" && (a[this.fileid] = e);
    },
    async getTemporaryResourceLink() {
      try {
        const e = await this.fileStorage.fetchResourceURL({ path: this.path });
        if (!e?.url) throw new Error("Resource URL is missing");
        return this.applyFetchedResource(e.url), this.updateStatus(t.loadSucceed), e;
      } catch (e) {
        return console.error("[CommentUploadFile] temp resource error", e), this.updateStatus(t.loadFailed), null;
      }
    },
    getDataCommentId(e) {
      if (e != null)
        return e.attributes.getNamedItem("data-comment-id") ? e.attributes.getNamedItem("data-comment-id")?.value.toString() : this.getDataCommentId(e?.offsetParent || null);
    },
    // Removed scheduled retry to avoid duplicate uploads; rely on manual retry only
    loadResourceLink() {
      try {
        this.updateStatus(t.loading);
        const e = this.$refs.rootCommentFile, a = this.getDataCommentId(e);
        a ? this.getPermanentResourceLink(a) : this.getTemporaryResourceLink();
      } catch (e) {
        console.error("loadResourceLink", e), this.retryCount++, this.retryCount < g && (this.updateStatus(t.loading), setTimeout(() => {
          this.loadResourceLink();
        }, 15e3));
      }
    },
    async getPermanentResourceLink(e) {
      const a = `${e}_${this.name}`;
      try {
        const i = await o.files.where("id").equals(a).first();
        if (!i)
          throw this.updateStatus(t.loadFailed), new Error("Permanent resource not found");
        this.displayType === "audio" ? this.applyFetchedResource(i.url) : ["image", "video"].includes(this.displayType) && (this.thumbnailUrl = this.displayType === "image" ? i.path : i.thumbnail), this.renderKey++, this.updateStatus(t.loadSucceed);
      } catch (i) {
        throw console.error("[CommentUploadFile] permanent link error", { error: i, _fileid: a }), this.updateStatus(t.loadFailed), new Error("Permanent resource not found");
      }
    },
    applyFetchedResource(e) {
      this.displayType === "audio" ? (this.resourceURL = e, r(() => {
        this.$refs.audioPlayerRef?.load?.();
      })) : this.thumbnailUrl = e;
    },
    async getURL() {
      try {
        const e = this.$refs.rootCommentFile, a = this.getDataCommentId(e);
        if (!a) return { data: null, commentId: null };
        const i = `${a}_${this.name}`;
        return { data: await o.files.where("id").equals(i).first(), commentId: a };
      } catch (e) {
        return console.error("getURL from IDB", e), { data: null, commentId: null };
      }
    },
    async handleOpenCommentFile(e) {
      if (this.displayType === "audio") {
        e.preventDefault();
        return;
      }
      const a = await this.getURL(), i = {
        mimeType: this.mimetype ?? null,
        name: this.name ?? null,
        data: a.data,
        commenttype: a.commentId ? "saved" : "temporary",
        timestamp: h.now().toFormat("HH:mm:ss"),
        path: this.path
      };
      this.bc?.postMessage(i);
    },
    onLoadSuccess() {
      this.updateStatus(t.loadSucceed);
    },
    retryUpload() {
      this.fileStorage?.retryUpload?.(this.fileid);
    },
    handleClick(e) {
      if (e === "delete") return this.fileStorage?.removeFile?.(this.fileid);
      const a = this.uploadStatus;
      return a <= t.uploading ? this.fileStorage?.stopUploading?.(this.fileid) : a === t.uploadFailed ? this.fileStorage?.retryUpload?.(this.fileid) : this.fileStorage?.removeFile?.(this.fileid);
    }
  }
};
export {
  v as _
};
